import styles from './style.module.css';
import Modal from 'react-responsive-modal';

interface IModalNoMoreAttempts {
  modalIsOpen: boolean;
  toggleModal: () => void;
}

export function ModalNoMoreAttempts({
  modalIsOpen,
  toggleModal,
}: IModalNoMoreAttempts) {
  return (
    <Modal
      open={modalIsOpen}
      onClose={() => {
        toggleModal();
      }}
      center
    >
      <div className={`${styles.modalBanner} ${styles.modalBannerDanger}`}>
        <i className="material-icons-outlined">block</i>
      </div>
      <div className={styles.contents}>
        <h2 className={styles.title}>
          <span className={styles.highlightText}>Que pena!</span> Suas
          tentativas acabaram.
        </h2>
        <p className={styles.detail}>
          Você não pontuou desta vez e não há mais tentativas disponíveis.
        </p>
        <p className={styles.caption}>
          Não desista: continue se engajando nos conteúdos!
        </p>
      </div>
      <div className={styles.contentBtn}>
        <button
          onClick={() => {
            toggleModal();
          }}
          className={styles.btnAgree}
          type="button"
        >
          OK
        </button>
      </div>
    </Modal>
  );
}
